import PrinceAbdullahbinGhazi1 from "../../assets/images/projects/1.ConstructionofPrinceAbdullahbinGhaziFacultyofCommunications/PrinceAbdullahbinGhazi1.jpeg";
import PrinceAbdullahbinGhazi2 from "../../assets/images/projects/1.ConstructionofPrinceAbdullahbinGhaziFacultyofCommunications/PrinceAbdullahbinGhazi2.jpeg";
import PrinceAbdullahbinGhazi3 from "../../assets/images/projects/1.ConstructionofPrinceAbdullahbinGhaziFacultyofCommunications/PrinceAbdullahbinGhazi3.jpeg";
import PrinceAbdullahbinGhazi4 from "../../assets/images/projects/1.ConstructionofPrinceAbdullahbinGhaziFacultyofCommunications/PrinceAbdullahbinGhazi4.jpeg";

import Dentistry1 from "../../assets/images/projects/2.ConstructionoftheEducationalClinicsBuilding—FacultyofDentistry/Dentistry1.jpeg";
import Dentistry2 from "../../assets/images/projects/2.ConstructionoftheEducationalClinicsBuilding—FacultyofDentistry/Dentistry2.jpeg";
import Dentistry3 from "../../assets/images/projects/2.ConstructionoftheEducationalClinicsBuilding—FacultyofDentistry/Dentistry3.jpeg";
import Dentistry4 from "../../assets/images/projects/2.ConstructionoftheEducationalClinicsBuilding—FacultyofDentistry/Dentistry4.jpeg";
import Dentistry5 from "../../assets/images/projects/2.ConstructionoftheEducationalClinicsBuilding—FacultyofDentistry/Dentistry5.jpeg";
import Dentistry6 from "../../assets/images/projects/2.ConstructionoftheEducationalClinicsBuilding—FacultyofDentistry/Dentistry6.jpeg";
import Dentistry7 from "../../assets/images/projects/2.ConstructionoftheEducationalClinicsBuilding—FacultyofDentistry/Dentistry7.jpeg";
import Dentistry8 from "../../assets/images/projects/2.ConstructionoftheEducationalClinicsBuilding—FacultyofDentistry/Dentistry8.jpeg";



import classroomssportshall1 from "../../assets/images/projects/3.ConstructionofClassroomsBuilding&SportsHall/classrooms-sports-hall-1.jpeg";
import classroomssportshall2 from "../../assets/images/projects/3.ConstructionofClassroomsBuilding&SportsHall/classrooms-sports-hall-2.jpeg";
import classroomssportshall3 from "../../assets/images/projects/3.ConstructionofClassroomsBuilding&SportsHall/classrooms-sports-hall-3.jpeg";
import classroomssportshall4 from "../../assets/images/projects/3.ConstructionofClassroomsBuilding&SportsHall/classrooms-sports-hall-4.jpeg";

import CivilDefence1 from "../../assets/images/projects/4.CivilDefenceDirectorateProject/CivilDefence1.jpeg";
import CivilDefence2 from "../../assets/images/projects/4.CivilDefenceDirectorateProject/CivilDefence2.jpeg";
import CivilDefence3 from "../../assets/images/projects/4.CivilDefenceDirectorateProject/CivilDefence3.jpeg";
import CivilDefence4 from "../../assets/images/projects/4.CivilDefenceDirectorateProject/CivilDefence4.jpeg";
import CivilDefence5 from "../../assets/images/projects/4.CivilDefenceDirectorateProject/CivilDefence5.jpeg";

import alrisha5 from "../../assets/images/projects/5.Al-RishaPowerStation/alrisha2.jpeg";
import alrisha6 from "../../assets/images/projects/5.Al-RishaPowerStation/alrisha3.jpeg";
import alrisha7 from "../../assets/images/projects/5.Al-RishaPowerStation/alrisha4.jpeg";
import alrisha8 from "../../assets/images/projects/5.Al-RishaPowerStation/alrisha5.jpeg";

import AjlounUniversityCollege1 from "../../assets/images/projects/6.ConstructionofClassroomsBuilding&SportsHall—AjlounUniversityCollege/AjlounUniversityCollege1.jpeg";
import AjlounUniversityCollege2 from "../../assets/images/projects/6.ConstructionofClassroomsBuilding&SportsHall—AjlounUniversityCollege/AjlounUniversityCollege2.jpeg";
import AjlounUniversityCollege3 from "../../assets/images/projects/6.ConstructionofClassroomsBuilding&SportsHall—AjlounUniversityCollege/AjlounUniversityCollege3.jpeg";
import AjlounUniversityCollege4 from "../../assets/images/projects/6.ConstructionofClassroomsBuilding&SportsHall—AjlounUniversityCollege/AjlounUniversityCollege4.jpeg";
import AjlounUniversityCollege5 from "../../assets/images/projects/6.ConstructionofClassroomsBuilding&SportsHall—AjlounUniversityCollege/img100.jpg";

import AlMarjSchool1 from "../../assets/images/projects/7.Al-MarjHousingMixedPrimarySchool/AlMarjSchool1.jpeg";
import AlMarjSchool2 from "../../assets/images/projects/7.Al-MarjHousingMixedPrimarySchool/AlMarjSchool2.jpeg";
import AlMarjSchool3 from "../../assets/images/projects/7.Al-MarjHousingMixedPrimarySchool/AlMarjSchool3.jpeg";
import AlMarjSchool4 from "../../assets/images/projects/7.Al-MarjHousingMixedPrimarySchool/AlMarjSchool4.jpeg";

import TechnologicalEngineering1 from "../../assets/images/projects/8.FacultyofTechnologicalEngineering/TechnologicalEngineering1.jpeg";
import TechnologicalEngineering2 from "../../assets/images/projects/8.FacultyofTechnologicalEngineering/TechnologicalEngineering2.jpeg";
import TechnologicalEngineering6 from "../../assets/images/projects/8.FacultyofTechnologicalEngineering/TechnologicalEngineering6.jpeg";

import royalJordanianAirForce1 from "../../assets/images/projects/9.RoyalAirForceCommand/RoyalAirForce1.jpeg";
import royalJordanianAirForce2 from "../../assets/images/projects/9.RoyalAirForceCommand/RoyalAirForce2.jpeg";
import royalJordanianAirForce3 from "../../assets/images/projects/9.RoyalAirForceCommand/RoyalAirForce3.jpeg";

import FireStation1 from "../../assets/images/projects/10.FireBrigadeandServiceBuildings—NewPortofAqaba/FireStation1.jpeg";

import ElectricityHousing from "../../assets/images/projects/11.ElectricityHousingMixedPrimarySchool/ElectricityHousing.jpeg";

import Safawi1 from "../../assets/images/projects/12.SafawiSolarElectricStation/Safawi1.jpeg";
import Safawi2 from "../../assets/images/projects/12.SafawiSolarElectricStation/Safawi2.jpeg";
import Safawi3 from "../../assets/images/projects/12.SafawiSolarElectricStation/Safawi3.jpeg";
import Safawi4 from "../../assets/images/projects/12.SafawiSolarElectricStation/Safawi4.jpeg";

import AqabaHealthCenter1 from "../../assets/images/projects/13.AqabaComprehensiveHealthCenter/AqabaComprehensiveHealth1.jpg";
import AqabaHealthCenter2 from "../../assets/images/projects/13.AqabaComprehensiveHealthCenter/AqabaComprehensiveHealth2.jpg";
import AqabaHealthCenter3 from "../../assets/images/projects/13.AqabaComprehensiveHealthCenter/AqabaComprehensiveHealth3.jpg";
import AqabaHealthCenter4 from "../../assets/images/projects/13.AqabaComprehensiveHealthCenter/AqabaComprehensiveHealth4.jpeg";
import AqabaHealthCenter5 from "../../assets/images/projects/13.AqabaComprehensiveHealthCenter/AqabaComprehensiveHealth5.jpeg";
import AqabaHealthCenter6 from "../../assets/images/projects/13.AqabaComprehensiveHealthCenter/AqabaComprehensiveHealth6.jpeg";

import BoundaryWallAdjacenttoNewFarm1 from "../../assets/images/projects/14.ConstructionofBoundaryWallAdjacenttoNewFarm/BoundaryWallAdjacenttoNewFarm1.jpeg";
import BoundaryWallAdjacenttoNewFarm2 from "../../assets/images/projects/14.ConstructionofBoundaryWallAdjacenttoNewFarm/BoundaryWallAdjacenttoNewFarm2.jpeg";
import BoundaryWallAdjacenttoNewFarm3 from "../../assets/images/projects/14.ConstructionofBoundaryWallAdjacenttoNewFarm/BoundaryWallAdjacenttoNewFarm3.jpeg";
import BoundaryWallAdjacenttoNewFarm4 from "../../assets/images/projects/14.ConstructionofBoundaryWallAdjacenttoNewFarm/BoundaryWallAdjacenttoNewFarm4.jpeg";

export const PROJECTS = [
   // ============================================================
  // 1. Prince Abdullah Bin Ghazi Faculty of Communications, IT & AI - Al-Balqa Applied University
  // ============================================================
  {
    slug: "prince-abdullah-bin-ghazi-faculty-of-communications-it-ai",
    title: "Prince Abdullah Bin Ghazi Faculty of Communications, IT & AI",
    category: "Education",
    status: "In Progress",
    client: "Al-Balqa Applied University",
    value: "JD 7,755,972",
    area: "16,497 m²",
    location: "Al-Salt, Jordan",
    started: "July 2024",
    supervisor: "Holy Rock Consultant Engineers",
    images: [
      PrinceAbdullahbinGhazi1,
      PrinceAbdullahbinGhazi2,
      PrinceAbdullahbinGhazi3,
      PrinceAbdullahbinGhazi4,
    ],
    description: [
      "A purpose-built academic facility for the Faculty of Communications and Information Technology at Al-Balqa Applied University's main campus in Al-Salt.",
      "The building comprises 7 main floors plus service facilities, featuring a modern auditorium (900 m²) and advanced Curtain Wall façades.",
      "Scope includes: infrastructure, excavation, grading, structural works with modern systems, architectural finishes, MEP (smart electrical, communications, HVAC, safety), external works (roads, parking, landscaping), aluminum curtain walls, skylights, and a state-of-the-art 900 m² auditorium with advanced audio and lighting systems."
    ],
    meta: [
      { label: "Client", value: "Al-Balqa Applied University" },
      { label: "Value", value: "JD 7,755,972" },
      { label: "Area", value: "16,497 m²" },
      { label: "Start Date", value: "July 2024" },
      { label: "Location", value: "Al-Salt" },
      { label: "Supervising Engineer", value: "Holy Rock Consultant Engineers" },
      { label: "Tender Duration", value: "730 Calendar Days" },
    ],
  },

  // ============================================================
  // 2. Educational Clinics Building - Faculty of Dentistry - The Hashemite University
  // ============================================================
  {
    slug: "educational-clinics-building-faculty-of-dentistry-hashemite-university",
    title: "Educational Clinics Building — Faculty of Dentistry",
    category: "Education",
    status: "In Progress",
    client: "The Hashemite University",
    value: "JD 7,669,033.5",
    area: "11,000 m²",
    location: "Zarqa, Jordan",
    started: "October 2025",
    supervisor: "Samat Engineering Consultants",
    images: [Dentistry1, Dentistry2, Dentistry3, Dentistry4, Dentistry5, Dentistry6, Dentistry7, Dentistry8],
    description: [
      "A specialized dental education facility comprising 4 main floors including clinical, educational, and administrative facilities.",
      "The building features 267 fully equipped dental clinics and clinical capacity of approximately 210 beds, representing a significant investment in dental education in Jordan.",
      "Scope includes: structural & architectural works for 10,593 m² building, 267 clinics, laboratories, lecture halls, admin offices, radiology, sterilization, loading/unloading; MEP (HVAC, electrical, fire protection, water, drainage, comms & control); supporting buildings (underground tank, pump, generator, transformer rooms, 70 m² gate building); external works (infrastructure, lighting, irrigation, roads, parking, fencing, gates); site preparation (demolition, excavation, backfilling, grading)."
    ],
    meta: [
      { label: "Client", value: "The Hashemite University" },
      { label: "Value", value: "JD 7,669,033.5" },
      { label: "Area", value: "10,593.95 m²" },
      { label: "Start Date", value: "October 2025" },
      { label: "Location", value: "Zarqa" },
      { label: "Supervising Engineer", value: "Samat Engineering Consultants" },
      { label: "Tender Duration", value: "600 Calendar Days" },
    ],
  },


  // ============================================================
  // 3. Classrooms Building & Sports Hall - Al-Balqa Applied University
  // ============================================================
  {
    slug: "classrooms-building-sports-hall-balqa-applied-university",
    title: "Classrooms Building & Sports Hall",
    category: "Education",
    status: "In Progress",
    client: "Al-Balqa Applied University",
    value: "JD 6,449,771.350",
    area: "11,000 m²",
    location: "Al-Salt, Jordan",
    started: "February 2024",
    supervisor: "Environmental Design Office",
    images: [
      classroomssportshall4,
      classroomssportshall3,
      classroomssportshall2,
      classroomssportshall1,
    ],
    description: [
      "Construction of classrooms building and sports hall at Al-Balqa Applied University – Ajloun University College.",
      "The project includes modern lecture halls and a multi-purpose sports hall.",
      "Scope includes: demolition of existing structures and old sports hall; 5-story classrooms complex (6605 m²) with labs and admin, plus a single-level sports hall (3986 m²) accommodating 1000+ persons; MEP (electrical, mechanical, generator room); retaining and boundary walls; excavation, sewage networks, stormwater drainage, fire water wells and tanks; guardhouse; external finishes and site preparation."
    ],
    meta: [
      { label: "Client", value: "Al-Balqa Applied University" },
      { label: "Value", value: "JD 6,449,771.350" },
      { label: "Area", value: "10,591 m² (Sports Hall 3,986 m² + Classrooms 6,605 m²)" },
      { label: "Start Date", value: "February 2024" },
      { label: "Location", value: "Ajloun" },
      { label: "Supervising Engineer", value: "Environmental Design Office" },
    ],
  },

  // ============================================================
  // 4. Civil Defense Directorate - Ma'an
  // ============================================================
  {
    slug: "civil-defense-directorate-maan",
    title: "Civil Defense Directorate Project",
    category: "Government",
    status: "Completed",
    client: "Civil Defense Directorate",
    value: "JD 3,938,967.55",
    area: "10,000 m²",
    location: "Ma'an, Jordan",
    started: "March 2018",
    supervisor: "Civil Defense Directorate",
    images: [CivilDefence2, CivilDefence4, CivilDefence3,CivilDefence5, CivilDefence1],
    description: [
      "A 10,000 m² main building for the Civil Defense Directorate in Ma'an with supporting facilities.",
      "The project includes canopies, asphalt yards, boundary walls, and service buildings with all civil, mechanical, and electrical works.",
      "Scope includes: main building (2 floors) with offices, operations rooms, admin, mosque, transport building, guest accommodation, guard towers, main entrance, fuel station, water/oil tank; metal canopies (2,500 m²); asphalt yards (25,000 m²); stone boundary walls (1,100 m); helipad; MEP (fire alarm, electrical, mechanical); infrastructure, external works, and landscaping."
    ],
    meta: [
      { label: "Client", value: "Civil Defense Directorate" },
      { label: "Value", value: "JD 3,938,967.55" },
      { label: "Area", value: "10,000 m² (Main Building)" },
      { label: "Start Date", value: "March 2018" },
      { label: "Location", value: "Ma'an" },
      { label: "Supervising Engineer", value: "Civil Defense Directorate" },
    ],
  },

  // ============================================================
  // 5. Al-Risha Power Station - NEPCO
  // ============================================================
  {
    slug: "al-risha-power-station",
    title: "Al-Risha Power Station",
    category: "Energy",
    status: "Completed",
    client: "NEPCO",
    value: "JD 3,365,487",
    area: "156 dunums",
    location: "Al-Risha, Jordan",
    started: "January 2023",
    supervisor: "NEPCO",
    images: [alrisha5, alrisha6, alrisha7, alrisha8],
    description: [
      "Al-Risha Power Station comprising 7 buildings across 156 dunums.",
      "The project includes all mechanical, electrical, and civil works."
    ],
    meta: [
      { label: "Client", value: "NEPCO" },
      { label: "Value", value: "JD 3,365,487" },
      { label: "Area", value: "156 dunums" },
      { label: "Start Date", value: "January 2023" },
      { label: "Supervising Engineer", value: "NEPCO" },
    ],
  },

  // ============================================================
  // 6. Classrooms Building - Ajloun University College
  // ============================================================
  {
    slug: "classrooms-ajloun-university-college",
    title: "Classrooms Building — Ajloun University College",
    category: "Education",
    status: "Completed",
    client: "Al-Balqa Applied University",
    value: "JD 3,183,507.2",
    area: "8,350 m²",
    location: "Ajloun, Jordan",
    started: "September 2021",
    supervisor: "Jamal Al-Shakhshir Engineering Consultants",
    images: [
      AjlounUniversityCollege1,
      AjlounUniversityCollege2,
      AjlounUniversityCollege3,
      AjlounUniversityCollege4,
      AjlounUniversityCollege5,
    ],
    description: [
      "A classroom complex at Ajloun University College consisting of 5 floors with a total area of 8,350 m².",
      "The project includes all necessary mechanical, electrical, and civil works.",
      "Scope includes: 5-story academic building with modern classrooms and educational support facilities; infrastructure, excavation, grading; high-quality interior/exterior finishes; stone, aluminum, and glass façades; MEP (VRF HVAC, electrical, lighting, data networks, fire suppression, fire alarm, security surveillance); external works (site grading, landscaping, irrigation, internal roads and pathways)."
    ],
    meta: [
      { label: "Client", value: "Al-Balqa Applied University" },
      { label: "Value", value: "JD 3,183,507.2" },
      { label: "Area", value: "8,350 m²" },
      { label: "Start Date", value: "September 2021" },
      { label: "Location", value: "Ajloun" },
      { label: "Supervising Engineer", value: "Jamal Al-Shakhshir Engineering Consultants" },
    ],
  },

 
  // ============================================================
  // 7. Al-Marj Mixed Primary School - Al-Karak
  // ============================================================
  {
    slug: "al-marj-mixed-primary-school-karak",
    title: "Al-Marj Mixed Primary School",
    category: "Education",
    status: "Completed",
    client: "Ministry of Public Works & Housing",
    value: "JD 3,039,531",
    area: "5,600 m²",
    location: "Al-Karak, Jordan",
    started: "October 2022",
    supervisor: "Al-Karak Works Directorate",
    images: [AlMarjSchool3, AlMarjSchool4, AlMarjSchool1, AlMarjSchool2],
    description: [
      "A mixed primary school in Al-Karak consisting of 6 floors with a total area of 5,600 m².",
      "The project includes all necessary mechanical, electrical, and civil works.",
      "Scope includes: excavation & backfilling; foundations and multi-story concrete structure; internal/external walls; interior/exterior finishes (flooring, walls, ceilings, painting); electrical wiring and lighting for all floors; distribution panels and control systems; water and sewage networks; external works (yards, pathways, stormwater drainage, external lighting, fencing and gates)."
    ],
    meta: [
      { label: "Client", value: "Ministry of Public Works & Housing" },
      { label: "Value", value: "JD 3,039,531" },
      { label: "Area", value: "5,600 m²" },
      { label: "Start Date", value: "October 2022" },
      { label: "Location", value: "Al-Karak" },
      { label: "Supervising Engineer", value: "Al-Karak Works Directorate" },
    ],
  },

    // ============================================================
  // 8. Teaching Halls - Faculty of Engineering Technology
  // ============================================================
  {
    slug: "teaching-halls-faculty-engineering-technology",
    title: "Teaching Halls Building — Faculty of Engineering Technology",
    category: "Education",
    status: "Completed",
    client: "Al-Balqa Applied University",
    value: "JD 2,230,579.109",
    area: "5,150 m²",
    location: "Al-Salt, Jordan",
    started: "January 2019",
    supervisor: "Holy Rock Consultant Engineers",
    images: [TechnologicalEngineering6, TechnologicalEngineering1, TechnologicalEngineering2],
    description: [
      "A teaching halls building for the Faculty of Engineering Technology spanning 5,150 m².",
      "The project includes all necessary mechanical, electrical, and civil works."
    ],
    meta: [
      { label: "Client", value: "Al-Balqa Applied University" },
      { label: "Value", value: "JD 2,230,579.109" },
      { label: "Area", value: "5,150 m²" },
      { label: "Start Date", value: "January 2019" },
      { label: "Location", value: "Al-Salt" },
      { label: "Supervising Engineer", value: "Holy Rock Consultant Engineers" },
    ],
  },


  // ============================================================
  // 9. Barracks Buildings - Royal Jordanian Air Force Command
  // ============================================================
  {
    slug: "barracks-buildings-royal-jordanian-air-force",
    title: "Barracks Buildings — Royal Jordanian Air Force Command",
    category: "Government",
    status: "Completed",
    client: "General Command",
    value: "JD 2,085,376.93",
    area: "5,000 m²",
    location: "Jordan",
    started: "June 2020",
    supervisor: "Royal Air Force / Technical & Engineering Support",
    images: [royalJordanianAirForce2, royalJordanianAirForce1, royalJordanianAirForce3],
    description: [
      "Barracks buildings for personnel at the Royal Jordanian Air Force Command spanning 5,000 m².",
      "The project includes all necessary mechanical, electrical, and civil works."
    ],
    meta: [
      { label: "Client", value: "General Command" },
      { label: "Value", value: "JD 2,085,376.93" },
      { label: "Area", value: "5,000 m²" },
      { label: "Start Date", value: "June 2020" },
      { label: "Supervising Engineer", value: "Royal Air Force / Technical & Engineering Support" },
    ],
  },


  // ============================================================
  // 10. Fire Brigade and Service Buildings - New Port of Aqaba
  // ============================================================
  {
    slug: "fire-brigade-service-buildings-new-port-aqaba",
    title: "Fire Brigade and Service Buildings — New Port of Aqaba",
    category: "Government",
    status: "Completed",
    client: "Aqaba Development Corporation",
    value: "JD 1,698,150.125",
    area: "5,500 m²",
    location: "Aqaba, Jordan",
    started: "April 2021",
    supervisor: "Holy Rock Consultant Engineers",
    images: [FireStation1],
    description: [
      "A two-story complex at the New Port of Aqaba spanning 5,500 m², including emergency, administrative, operational, and support facilities.",
      "The project includes all civil, mechanical, and electrical works to support port operations and emergency response capabilities.",
      "Scope includes: foundations and concrete structure; metal structures and canopies; finishes (paint, flooring, doors, windows, office fit-out); MEP (HVAC, ventilation, fire alarm & suppression, operations rooms); external works (roads, pathways, sewage, lighting)."
    ],
    meta: [
      { label: "Client", value: "Aqaba Development Corporation" },
      { label: "Value", value: "JD 1,698,150.125" },
      { label: "Area", value: "5,500 m²" },
      { label: "Start Date", value: "April 2021" },
      { label: "Location", value: "Aqaba" },
      { label: "Supervising Engineer", value: "Holy Rock Consultant Engineers" },
    ],
  },


  
  // ============================================================
  // 11. Electricity Housing Mixed Primary School
  // ============================================================
  {
    slug: "electricity-housing-mixed-primary-school",
    title: "Electricity Housing Mixed Primary School",
    category: "Education",
    status: "Completed",
    client: "Ministry of Public Works & Housing",
    value: "JD 1,657,358.505",
    area: "",
    location: "Jordan",
    started: "February 2016",
    supervisor: "",
    images: [ElectricityHousing],
    description: [
      "Electricity Housing Mixed Primary School.",
      "The project includes all necessary mechanical, electrical, and civil works."
    ],
    meta: [
      { label: "Client", value: "Ministry of Public Works & Housing" },
      { label: "Value", value: "JD 1,657,358.505" },
      { label: "Start Date", value: "February 2016" },
    ],
  },


  // ============================================================
  // 12. Safawi Solar Electric Station
  // ============================================================
  {
    slug: "safawi-solar-electric-station",
    title: "Safawi Solar Electric Station",
    category: "Energy",
    status: "Completed",
    client: "NEPCO (National Electric Power Co.)",
    value: "JD 1,256,105.38",
    area: "5,000 m²",
    location: "Safawi, Jordan",
    started: "September 2017",
    supervisor: "NEPCO",
    images: [Safawi1, Safawi2, Safawi3, Safawi4],
    description: [
      "Safawi Solar Electric Station for renewable energy electricity generation.",
      "The project covers an area of 5,000 m² and was executed for NEPCO."
    ],
    meta: [
      { label: "Client", value: "NEPCO" },
      { label: "Value", value: "JD 1,256,105.38" },
      { label: "Area", value: "5,000 m²" },
      { label: "Start Date", value: "September 2017" },
      { label: "Location", value: "Safawi" },
      { label: "Supervising Engineer", value: "NEPCO" },
    ],
  },


  // ============================================================
  // 13. Comprehensive Health Center - Aqaba
  // ============================================================
  {
    slug: "comprehensive-health-center-aqaba",
    title: "Comprehensive Health Center — Aqaba",
    category: "Healthcare",
    status: "Completed",
    client: "Ministry of Public Works & Housing",
    value: "JD 1,138,436.200",
    area: "",
    location: "Aqaba, Jordan",
    started: "September 2021",
    supervisor: "Aqaba Works Directorate",
    images: [
      AqabaHealthCenter1,
      AqabaHealthCenter6,
      AqabaHealthCenter4,
      AqabaHealthCenter5,
      AqabaHealthCenter2,
      AqabaHealthCenter3,
    ],
    description: [
      "A comprehensive health center in Aqaba consisting of 6 floors.",
      "The project includes all necessary mechanical, electrical, and civil works to deliver a fully functional healthcare facility serving the local community."
    ],
    meta: [
      { label: "Client", value: "Ministry of Public Works & Housing" },
      { label: "Value", value: "JD 1,138,436.200" },
      { label: "Start Date", value: "September 2021" },
      { label: "Location", value: "Aqaba" },
      { label: "Supervising Engineer", value: "Aqaba Works Directorate" },
    ],
  },

  // ============================================================
  // 14. Boundary Wall Adjacent to New Farm - Arab Potash Company
  // ============================================================
  {
    slug: "boundary-wall-new-farm-arab-potash",
    title: "Boundary Wall Adjacent to New Farm",
    category: "Industrial",
    status: "Completed",
    client: "Arab Potash Company",
    value: "JD 131,505.51",
    area: "",
    location: "Jordan",
    started: "March 2022",
    supervisor: "Arab Potash Company",
    images: [
      BoundaryWallAdjacenttoNewFarm1,
      BoundaryWallAdjacenttoNewFarm2,
      BoundaryWallAdjacenttoNewFarm3,
      BoundaryWallAdjacenttoNewFarm4,
    ],
    description: [
      "Construction of boundary wall adjacent to a new farm for Arab Potash Company.",
      "Reference: PO.202200757No."
    ],
    meta: [
      { label: "Client", value: "Arab Potash Company" },
      { label: "Value", value: "JD 131,505.51" },
      { label: "Start Date", value: "March 2022" },
      { label: "Supervising Engineer", value: "Arab Potash Company" },
      { label: "Reference", value: "PO.202200757No" },
    ],
  },
];